module.exports = __webpack_public_path__ + "img/about-top-mobile.88865a2a.png";